import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/portal/app/components/categories-navigation-carousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/badge.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/social/facebook-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/social/instagram-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/social/pinterest.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/social/twitter-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Product/base/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/modules/src/shared/Product/common/ProductAccordionBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Product/product-order-details/faqs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Product/product-order-details/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Product/product-order-details/ingredient/key/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Product/product-order-details/testimonials/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Product/views/detailed-digital-product-view/details/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
